import React, { useState } from "react";

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // alert("Working on this")
    const form = e.target;

    await fetch("https://formsubmit.co/ajax/gradiance.in@gmail.com", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        name: form.name.value,
        email: form.email.value,
        phone: form.phone.value,
        message: form.message.value,
      }),
    });

    form.reset();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 2000);
  };

  return (
    <section id="enquiry" className="mt-10 py-20 px-6 bg-gray-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left: Form */}
        <div className="bg-white p-8 rounded-xl shadow-lg">
          <h2 className="text-2xl font-bold mb-6 text-center">Contact Us</h2>

          {submitted && (
            <div className="mb-4 text-green-600 text-center font-medium transition duration-300">
              ✅ Thank you! Your message has been sent.
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              required
              placeholder="Your Name"
              className="w-full border border-gray-300 rounded-lg p-3"
            />
            <input
              type="email"
              name="email"
              required
              placeholder="Your Email"
              className="w-full border border-gray-300 rounded-lg p-3"
            />
            <input
              type="tel"
              name="phone"
              required
              inputMode="numeric"
              pattern="^[0-9]+$"
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
              placeholder="Phone Number"
              className="w-full border border-gray-300 rounded-lg p-3"
            />
            <textarea
              name="message"
              required
              placeholder="Your Message"
              rows="4"
              className="w-full border border-gray-300 rounded-lg p-3"
            ></textarea>

            <button
              type="submit"
              className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition w-full"
            >
              Submit Message
            </button>
          </form>
        </div>

        {/* Right: Image */}
        <div className="hidden md:block">
          <img
            src="/staticImages/contact.png"
            alt="Contact Illustration"
            className="rounded-xl shadow-lg w-full h-auto object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
